import Backbone from 'backbone';
import _ from 'underscore';
import i18n from '../i18n';

import Field from '../model/refbooks/field';
import Fields from '../collection/refbooks/fields';
import View from './view';

import { hashify } from '../utils/arrays';
import { flatify } from '../model/refbooks/field.utils';
import Collection from '../collection';





let ifn; i18n.then( i => ifn = i );

export default View.extend( {
    
    initialize(options = {}) {
        this.gather = options.gather || this.gather;
        
        View.prototype.initialize.apply( this, arguments );
    },
    
    events: {
        
        'keyup textarea': function(e) {
            if (13 === e.keyCode)
                e.stopPropagation();
        }
        
    },
    
    validate() {
        const { fields } = this.options;

        const fl = fields => flatify( fields )
            .filter( field => field.default_value != undefined && field.default_value != '' )
        const defvals = hashify( 
            fl( new Fields( fields instanceof Collection ? fields.toJSON() : fields ).nonSystem() ),
            ({ translit, format, default_value }) => [
                translit, 
                format === 'bool' ? default_value === 'true' : default_value] );

        const take = ([prop, ...rest], here = {}, is_new = false) => {
            if (here == undefined)
                return [here, is_new]; // null -> null, undefined -> undefined

            if (!prop)
                return typeof here == 'object'
                    ? [here.values, is_new] // Data-Table with values
                    : [here, is_new];       // Any other type of Custom field

            if (!here[prop])
                return [undefined, is_new];

            return here instanceof Array
                ? take( rest, here[prop], is_new || !here[prop].guid )        // Composite[index]
                : take( rest, here[prop].value, is_new ); // Any other type of Custom field
        };

        const val = name => {
            const path = name.split( /\.|\[|\]/ )
                .map( s => Field.decodeString( s ) )
                .filter( s => s.length );
            const [value, is_new] = take( 
                path, 
                this.model.get( 'fields' ) || {}, 
                !this.model.id );
            return value
                ? [value, is_new]
                : [path.length === 1 ? this.model.get( name ) : value, is_new];
        };

        const messages = [...this.$( '[required]:not([disabled]):visible' )]
            .map( el => this.$( el ) )
            .filter( $el => 
                $el.closest( '.disabled' ).length == 0 && 
                $el.closest( '[disabled]' ).length == 0 )
            .map( $el => {
                const path = $el.attr( 'name' );
                const [encodedTranslit] = path.split( '.' ).reverse();
                const translit = Field.decodeString( encodedTranslit );

                const [value, is_new] = val( path );
                return value === undefined && is_new
                    ? [defvals[translit], $el]
                    : [value, $el];
            } )
            .filter( ([value]) => 
                value == undefined ||
                value === '' || 
                value instanceof Array && value.length === 0 ||
                typeof value === 'boolean' && !value )
            .map( ([value, $el]) => [ifn( 'forms::required field' ), $el[0], value] )

        return { 
            result: messages.length === 0, 
            messages
        };
    },

    commit() {
        this.originalModel = this.model.clone();
    },

    rollback() {
        this.model.set( this.originalModel.toJSON() );
    },

    diff(options = {}) {
        return this.model
            ? this.model.diff( this.originalModel, options )
            : [];
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    }
   
}, {

    handleHttpError(form, response) {
        const [[xhr, textStatus, errorThrown]] = response;

        setTimeout( () => form.focus(), 0 );
        throw Backbone.ajax.parseError( xhr, textStatus, errorThrown );
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/form.js